import { useCollectionStateContext } from 'Context/CollectionStateContext';
import DataContainer from 'Components/UI/DataContainer';
import React from 'react';
import {
  TaxDiagnosticNoteContent,
} from 'Views/Page/Content/Templates/TaxDiagnosticPlannerPage/TaxDiagnosticTemplate/TaxDiagnosticNotes/Content';

export const Container = () => {
  const { isInitializing, loading, loadingError } = useCollectionStateContext();

  return (
    <DataContainer
      component={TaxDiagnosticNoteContent}
      loading={loading || isInitializing}
      loadingError={loadingError}
    />
  );
};
